"use strict";

export { default } from './BottomSheetGestureHandlersProvider';
//# sourceMappingURL=index.js.map